import { useEffect, useRef } from 'react'
import BaseBox from '../../component/BaseBox'
import BaseBoxBg from '../../component/BaseBoxBg'
import FullLaout from '../../component/FullLayout'
import NoticeItem from '../../component/NoticeItem'
import TopLeft from '../../component/TopLeft'
import useHomeList from '../../hooks/component/useHomeList'
import './index.less'
import BottomFalg from '../../component/BottomFalg'


const MoreNotice = () => {
    const { moreNoticeList, getMoreNoticeList ,getNoticeList} = useHomeList()

    const nextPage = (e) => {
        const {scrollTop, scrollHeight, clientHeight} = listContentRef.current
        // const { scrollTop, scrollHeight,  } = e.target;
        const scrollContainer = e.target;
        const previousScrollHeight = scrollContainer.scrollHeight;
        console.log('sadfa', scrollTop, scrollHeight, clientHeight)
        if(scrollHeight - scrollTop <= clientHeight + 50){
            getMoreNoticeList()
            console.log('asdfasdfasfa',)
        }
    }
    const listContentRef = useRef(null)
    useEffect(() => {
        getNoticeList(30)
        const listContent = listContentRef.current
        if (listContent) {
            listContent.addEventListener('scroll', nextPage)
        }
        return () => {
            if (listContent) {
                listContent.removeEventListener('scroll', nextPage)
            }
        }
        
    }, [])
    return <FullLaout title={'公告列表'} rightIcon={<></>} showFooter={false}>
        <BaseBox style={{ padding: "0 0.16rem", }} >
            <div ref={listContentRef} style={{overflowY:"auto"}}>
                {moreNoticeList?.list?.map((info, i) => (
                    <NoticeItem key={i} info={info} create_time={new Date().formatFullTime(info?.create_time)} />
                ))}
            </div>


        </BaseBox>

        {/* <BottomFalg  {... (noticeList?.length<10 && {style:{position:"fixed", bottom:"0.2rem", width:"100%", }})}/> */}
    </FullLaout>
}
export default MoreNotice